import { render, staticRenderFns } from "./MtSaleOrders.vue?vue&type=template&id=dfb05050&scoped=true&"
import script from "./MtSaleOrders.vue?vue&type=script&lang=js&"
export * from "./MtSaleOrders.vue?vue&type=script&lang=js&"
import style0 from "./MtSaleOrders.vue?vue&type=style&index=0&id=dfb05050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb05050",
  null
  
)

export default component.exports